import { useEffect, useRef } from "react";

import styled from "styled-components/macro";

import {
  useShowCompleteSplash,
} from "Flocknote/stateHooks";

import extendedFieldHooks from "ExtendedFields/selectorHooks";

import FnrFade from "UI/FnrFade/FnrFade";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import useIsWiderThan from "Utilities/Hooks/useIsWiderThan";

import FlocknotePeopleSplash from "splashes/FlocknotePeopleSplash/FlocknotePeopleSplash";

import ErrorMessage from "./ErrorMessage";
import FullUI from "./FullUI";
import ThinUI from "./ThinUI";

const SFnrVerticalGap = styled(FnrVerticalGap)`
  height: 100%;
  font-weight: 400;
`;

const FlexContainer = styled("div")`
  overflow: hidden;
  display: flex;
  flex-direction: row;
`;

const ExtendedFieldsManager = () => {
  // initialize data for component
  const [isLoading, initExtendedFields] =
    extendedFieldHooks.useInitExtendedFields();
  const hasExtendedFields = extendedFieldHooks.useHasExtendedFields();
  const hasAvailableFields = extendedFieldHooks.useHasAvailableFields();

  useEffect(() => {
    const init = async () => await initExtendedFields();

    init();
  }, [initExtendedFields]);

  // determine how this should be displayed
  const containerRef = useRef();
  const [displayIsFullWidth, setDisplayIsFullWidth] =
    extendedFieldHooks.useDisplayIsFullWidth(containerRef);
  const show = !isLoading || hasExtendedFields || hasAvailableFields;
  const isWiderThan = useIsWiderThan(containerRef, {
    refreshTrigger: show,
  });
  const [editWithModal] = extendedFieldHooks.useEditWithModal();

  useEffect(() => {
    setDisplayIsFullWidth(editWithModal ? false : isWiderThan);
  }, [isWiderThan, setDisplayIsFullWidth, editWithModal]);

  // show sales blurb if applicable.
  const [showCompleteSplash] = useShowCompleteSplash();
  if (showCompleteSplash)
    return <FlocknotePeopleSplash successCallback={initExtendedFields} />;

  return (
    <>
      <FnrFade show={show || editWithModal} height="100%" ref={containerRef}>
        <SFnrVerticalGap
          ref={containerRef}
          data-cy="ExtendedFieldsManager"
          gap={0}
        >
          <FlexContainer>
            {displayIsFullWidth ? <FullUI /> : <ThinUI />}
          </FlexContainer>
          <ErrorMessage />
        </SFnrVerticalGap>
      </FnrFade>
      {/* <FnrLoadingBricks show={isLoading} size={48} /> */}
    </>
  );
};

export default ExtendedFieldsManager;
